<template>
    <div class="container">
        <div class="filter">
            <div class="select" v-if="classify != 'TELEMETRY_DISPLACEMENT'&&classify != 'EQUIPMENT_FAILURE'&&classify != 'DEVICE_FAILURE'">
                <el-select v-model="eventType" @change="$emit('filter', eventType)">
                    <el-option
                        v-for="item in options"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                    </el-option>
                </el-select>
            </div>
            <div class="date-picker">
                <el-date-picker
                    v-model="dateRange"
                    type="daterange"
                    unlink-panels
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    format="yyyy 年 MM 月 dd 日"
                    :default-time="['00:00:00', '23:59:59']"
                    @change="$emit('query', dateRange)">
                </el-date-picker>
            </div>
        </div>
        <div class="count">
            共<span>{{ count }}</span>条
        </div>
    </div>
</template>

<script>
export default {
    props: {
        count: Number,
        types: Array,
        classify:String
    },
    data () {
        return {
            eventType: '',
            dateRange: '',
        }
    },
    computed: {
        options: function () {
            let op = this.types.map(item => {
                return {
                    value: item,
                    label: item + '报警',
                }
            })
            op.unshift({label: '全部', value: ''});

            return op;
        }
    },
    watch: {
        types: function(val, oldVal) {
            this.eventType = '';
        }
    }
}
</script>

<style lang="less" scoped>
.container {
    .h(88);
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-width: 1px;
    background: white;
}
.filter {
    display: flex;
    padding-left: 24rem;
}
.el-select {
    .w(260);
}
.date-picker {
    padding-left: 24rem;
}
.button {
    padding-left: 24rem;
}
.count {
    padding-right: 24rem;
    font-size: 18rem;
    font-weight: 500;

    span {
        color: #0D94FF;
    }
}
</style>